// 特色课堂
import React, { useContext } from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import cls from 'classnames';

import { PC } from '@wukong/haomao';
import Title from '../Title';
import { MyContext } from '../../../../config/context-manager';
import styles from './style.module.scss';

const CourseFeatures = () => {
  const { t } = useTranslation('chineseSpecialty');
  const { locale } = useContext(MyContext);
  return (
    <section
      className={cls(styles.container, {
        [styles.localeEn]: locale === 'en',
      })}
    >
      <Title> {t('特色课堂-标题')} </Title>
      <div className={styles.contentContainer}>
        <div className={`${styles.flexItem} ${styles.content}`}>
          <h3 dangerouslySetInnerHTML={{ __html: t('特色课堂-副标题') }} />
          <p className={styles.mt12}>{t('特色课堂-内容-1')}</p>
          <p className={styles.mt24}>{t('特色课堂-内容-2')}</p>
        </div>
        <div className={`${styles.flexItem} ${styles.contentImg}`}>
          <div className={styles.bg}>
            <Image
              src="/images/chinese-math-class/chinese/specil/features-omtroduce-bg.png"
              width={636}
              height={546}
              layout="responsive"
              alt="悟空中文 特色课堂"
            />
          </div>
          <PC>
            <div className={styles.icon}>
              <Image
                src="/images/chinese-math-class/chinese/specil/features-sreach-icon.png"
                width={190}
                height={190}
                alt=""
              />
            </div>
          </PC>
        </div>
      </div>
    </section>
  );
};

export default CourseFeatures;
